import { useTranslation } from "react-i18next";
import InfoLayout from "./InfoLayout";
import "../../styles/InfoPage.css";

export default function ShippingPage() {
  const { t } = useTranslation("shipping");

  return (
    <InfoLayout title={t("title")}>
      <h2 className="infoH2">{t("heading1")}</h2>

      <p className="infoP">
        {t("text1")}
      </p>

      <p className="infoP">
        {t("text2_before")} <strong>{t("text2_strong1")}</strong>.{" "}
        {t("text2_middle")} <strong>{t("text2_strong2")}</strong>.
      </p>

      <h2 className="infoH2">{t("heading2")}</h2>

      <p className="infoP">
        {t("text3")}
      </p>
    </InfoLayout>
  );
}